import flattenTagValue from "./flattenTagValue.js";
export default function tagToValues(tag) {
    if (Array.isArray(tag.data.value)) {
        return tag.data.value.map((t) => tagToValues({
            ...tag,
            data: {
                ...tag.data,
                value: t,
            },
        }));
    }
    else if (typeof tag.data.value === "object") {
        // @ts-expect-error
        return flattenTagValue(tag.data.value);
    }
    else
        return tag.data.value;
}
